<template>
    <!-- 上传文档的操作区域封装组件 -->
    <div class="uploadAction">
  
      <!-- <a-form-item 
        模板暂时没有，点击报错，暂时先注掉--2023/8/23 11：44
        label="下载模板"
      >
        <a-button @click="download" style="background: #2caf7a;border: 1px solid #2caf7a;color: #fff">下载模板</a-button>
      </a-form-item> -->
  
      <a-form-item
        label="上传"
        :labelCol="labelCol" :wrapperCol="wrapperCol"
      >
        <a-upload
          accept=".jpg,.png,.jpeg"
          @change='handleChange'
          :remove="handleRemove"
          :before-upload="beforeUpload"
          :action="this.axios.defaults.baseURL+'/common/upload'"
          :headers="token"
          :default-file-list="defaultFileList"
          :fileList="acceptFileList"
         
        >
  <!--        accept=".doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"-->
          <a-button class="uploads" v-if="this.fileList.length<5" style="width:200px;height:50px;"> <a-icon type="upload" />选择文件</a-button>
        </a-upload>
        <!-- <a-button style="margin:20px 0 0 150px;" @click="beginUpload">开始上传</a-button> -->

      </a-form-item>
    </div>
  </template>
  
  <script>
  export default {
    name:"paymentVoucherUpload",
    mounted() {
      if(this.checkFlag === true){
        this.defaultFileList = []
      }
      // if (!this.docUrl) {
      //   this.showFlag = true;
      // } else if (!this.checkFlag) {
      //   this.showFlag = true;
      //   this.title = "重新上传";
      // }
    },
    props: {
      checkFlag: {
        required: true,
        type: Boolean,
      },
    },
    data() {
      return {
        fileList: [],
        uploading: false,
        remark: "",
        title: "上传",
        showFlag: false,
        token:{'X-Access-Token':localStorage.getItem('token')},
        defaultFileList:[],
        fileListName:[],
        getFileList:[],
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 }
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 }
        },
        acceptFileList:[]
      };
    },
    created(){
      
    },
    methods: {
      beginUpload(){
       return this.getFileList
      },

      clearUpload(){
        this.getFileList = []
        this.defaultFileList = []
        this.acceptFileList = []
      },
      download(){
        this.axios.get(`/student/departParam/all`,{
          params:{
            eduCode:JSON.parse(localStorage.getItem('userInfo')).eduCode,
            paramKey:'default_xjydsqb'
          }
        }).then(res=>{
          if(res.code === 200){
            window.open(res.result[0].paramVal)
          }
        })
      },
      beforeUpload(info){
        
        this.acceptFileList = [...this.acceptFileList, info];
        if(info.type !== 'image/png' && info.type !== 'image/jpeg' && info.type !== 'image/jpg'){
          this.$message.warning('您只能上传jpg,png,jpeg文件!')
          this.acceptFileList.pop()
        }
      },
      handleChange(info) {
        console.log(info.file.status)
        console.log(this.fileList,'this.fileList')
        if (info.file.status !== 'uploading') {
        }
        if(info.file.status === "removed"){
      
          this.fileList.forEach((item,index)=>{
            if(item == info.file.response.result){
              this.fileList.splice(index,1)
              this.acceptFileList.splice(index,1)
            }
          })
          this.fileListName.forEach((item,index)=>{
            if(item == info.file.name){
              this.fileListName.splice(index,1)
            }
          })
          this.$emit('uploadSuccessList',this.fileList)
          this.$emit('uploadSuccess',this.fileListName)
        }
        if (info.file.status === 'done'&&info.file.response.code===200) {
          this.getFileList.push(info.file)

          this.fileList.push(info.file.response.result)
          this.fileListName.push(info.file.name)
          // this.$message.success('上传成功');
          // this.defaultFileList = []
          // this.fileList = []
          this.$emit("uploadSuccessList",this.fileList);
          this.$emit("uploadSuccess",this.fileListName);
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} file upload failed.`);
        }else if(info.file.response.code===500){
        this.$message.error(info.file.response.message);
        this.acceptFileList.pop()

      }

        
      },
      /** 该函数是在向服务器上传文件之前的拦截器，判断上传的文件是否符合规则（文件类型为.doc和.docx，文件大小不得大于20MB）
       * @param {object} file 上传文件的对象
       */
      // beforeUpload(file) {
        // application/vnd.openxmlformats-officedocument.wordprocessingml.document
        // application/msword
        // 这两个type类型分别为.doc和.docx
        //   const isJpgOrPng =
        //     file.type ===
        //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        //     file.type === "application/msword";
        //   if (!isJpgOrPng) {
        //     this.$message.error("只能上传word文档！");
        //   }
        //   const isLt2M = file.size / 1024 / 1024 < 20;
        //   if (!isLt2M) {
        //     this.$message.error("只能上传小于20MB的文档！");
        //   }
        //   return isJpgOrPng && isLt2M;
      //   this.fileList = [file];
      //   return false;
      // },
      beforeUpload1(file) {
        const isJpgOrPng =
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/msword";
        if (!isJpgOrPng) {
          this.$message.error("只能上传word文档！");
        }
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isLt2M) {
          this.$message.error("只能上传小于20MB的文档！");
        }
        return isJpgOrPng && isLt2M;
      },
      handleUpload() {
        const { fileList } = this;
        const formData = new FormData();
        formData.append("file", fileList[0]);
        this.uploading = true;
        this.axios
          .post(`/common/upload`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.success && res.result) {
              this.axios
                .get(`/biz/archive/doc/upload`, {
                  params: {
                    target: res.result,
                    targetName: fileList[0].name,
                    type: this.type,
                    remark: this.remark,
                  },
                })
                .then((res2) => {
                  if (res.success) {
                    this.uploading = false;
                    this.fileList = [];
                    this.remark = "";
                    this.$message.success("上传成功！");
                    this.$emit("uploadSuccess",false);
                  } else {
                    this.$message.error(res.message);
                  }
                });
            }
          });
      },
      handleRemove(file) {
        this.getFileList.splice(-1)
      },
    },
  };
  </script>
  
  <style lang="stylus" scoped>
  @import '~styles/varibles.styl';
  @import '~styles/mixins.styl';
  
  .btn {
    background: $bgColor;
    color: #fff;
    width: 120px;
    margin: 20px;
  }
  
  .btn-info {
    background: $bgColor;
  }
  
  .btn-text {
    color: #c4c4c4;
    display: block;
    margin: 10px 0;
  }
  
  .form-group {
    margin: 10px 0;
    display: flex;
    align-items: center;
  }
  
  .uploads {
    width: 200px;
    height: 50px;
    color: $bgColor;
    display: inline-block;
    font-size: 16px;
  }
  
  .uploadAction {
    label {
      width: 100px;
    }
  /deep/ .ant-upload-list {
  width: 100%;
  max-height: 100%;
  overflow:hidden;
  .ant-upload-list-item-name {
  color: #2caf7a;
}
}
  }
  
  .customScrollBar div::-webkit-scrollbar-thumb {
    background-color: $bgColor !important;
  }
  
  .WACFrameWord {
    /* background: top left repeat-x #ffffff; */
    /* background-attachment: fixed; */
    /* background-image: -webkit-gradient(linear,left top,left bottom,from(#ffffff),to(#F3F3F3)); */
    /* background-image: -moz-linear-gradient(top,#ffffff,#F3F3F3);
    background-image: -ms-linear-gradient(top,#ffffff,#F3F3F3); */
    background: #f00 !important;
  }
  
  .disabled {
    background-color: #cccccc!important;
    border: none;
  }
  </style>
  
  <style>
  .disabled {
    background-color: #cccccc!important;
    border: none;
  }
  </style>
  


// WEBPACK FOOTER //
// src/pages/documentDetail/components/paymentVoucherUpload.vue